import Command from './command';
import CommandResult from './command-result';
import { classForType } from '@intercom/embercom-composer/blocks/types/base/block';
import { findAddedChars, findRemovedChars } from '@intercom/embercom-composer/lib/text-diff';
export default Command.extend({
  skipItemSelections: true,
  processZeroWidth() {
    if (this.get('firstSelectedBlock.isEditable')) {
      return this._doSync();
    }
    // We pretend like we did a sync for non-editable blocks so that we
    // don't continually re-render and update UI selection as this would
    // break pop-overs - TODO: This is ugh.
    return CommandResult.create({
      didSync: true
    });
  },
  processSingleBlock() {
    return CommandResult.create({
      didSync: false
    });
  },
  processMultiBlock() {
    return CommandResult.create({
      didSync: false
    });
  },
  _createDummyBlock(type, replacementsToSkip) {
    return classForType(type).create({
      text: this.get('options.html'),
      config: this.get('config'),
      replacementsToSkip
    });
  },
  _doSync() {
    let currentBlock = this.get('firstSelectedBlock');
    if (this.get('firstSelectedBlock.isListType')) {
      return this._delegateToFirstSelectedBlock();
    }
    if (currentBlock.get('isMedia')) {
      throw new Error('trying to do a sync on a non-text block is not supported');
    }
    let dummyBlock = this._createDummyBlock(currentBlock.get('type'), currentBlock.get('replacementsToSkip'));
    let shouldRerender = this.runInlineReplacements(dummyBlock, currentBlock);
    currentBlock.set('entities', dummyBlock.get('entities'));
    let result = currentBlock.updateText(dummyBlock.get('text'), this.get('config'));
    result = this.processBlockMutationResult(result, shouldRerender);
    result.set('didSync', true);
    return result;
  },
  _delegateToFirstSelectedBlock() {
    let blockList, selection;
    this._setItemSelections();
    blockList = this.get('firstSelectedBlock.blockList');
    selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    let result = this.constructor.create({
      blockList,
      selection,
      options: this.get('options'),
      config: this.get('config')
    }).run();
    this.setSelectionToPositionIndex(selection.get('startPositionIndex'));
    return result;
  },
  // prettier-ignore
  _calculateCaretOffset(originalCaretIndex, textBefore, textAfter) {
    let textLeftOfCursorBefore = textBefore.slice(0, originalCaretIndex);
    let textRightOfCursorBefore = textBefore.slice(originalCaretIndex);
    let textLeftOfCursorAfter = textAfter.slice(0, originalCaretIndex);
    let textRightOfCursorAfter = textAfter.slice(originalCaretIndex);
    let textLeftOfCursorAdded = findAddedChars(textLeftOfCursorBefore, textLeftOfCursorAfter).join('');
    let textLeftOfCursorRemoved = findRemovedChars(textLeftOfCursorBefore, textLeftOfCursorAfter).join('');
    let textRightOfCursorRemoved = findRemovedChars(textRightOfCursorBefore, textRightOfCursorAfter).join('');
    let newCharsLeftOfCurserAfter = findAddedChars(textRightOfCursorRemoved, textLeftOfCursorAdded);
    return newCharsLeftOfCurserAfter.length - textLeftOfCursorRemoved.length;
  },
  // prettier-ignore
  runInlineReplacements(dummyBlock, currentBlock) {
    let textBefore = dummyBlock.get('text');
    dummyBlock.doInlineReplacementsWithIndex(this.get('selection.startPositionIndex'));
    let textAfter = dummyBlock.get('text');
    if (textBefore !== textAfter) {
      let offset = this._calculateCaretOffset(this.get('selection.startPositionIndex'), textBefore, textAfter);
      this.moveSelectionRightBy(offset);
      return true;
    }
    // TODO: POB: This only seems to be needed to make toggle mode tests pass
    if (!currentBlock.hasSameEntitiesAs(dummyBlock)) {
      return true;
    }
    return false;
  }
});